var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnkh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M296 272H227.125C256.5 235.625 281.875 184.125 281.875 137.125C281.875 53 227.375 0 160 0S38.125 53 38.125 137.125C38.125 184.125 63.5 235.625 92.875 272H24C10.745 272 0 282.745 0 296V296C0 309.255 10.745 320 24 320H136V488C136 501.255 146.745 512 160 512H160C173.255 512 184 501.255 184 488V320H296C309.255 320 320 309.255 320 296V296C320 282.745 309.255 272 296 272ZM160 48C204.25 48 233.875 83.875 233.875 137.125C233.875 191 184.25 256.625 160 270.5C135.75 256.625 86.125 191 86.125 137.125C86.125 83.875 115.75 48 160 48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnkh);
export default __webpack_public_path__ + "static/media/ankh.f700465d91bcd2b2e96909c1f134ae81.svg";
export { ForwardRef as ReactComponent };